import React from 'react'

const NotFound = () => {
  return (
    <div>
      Page Not Fount
    </div>
  )
}

export default NotFound
